// extracted by mini-css-extract-plugin
module.exports = {"infoContainer":"styles_infoContainer__A6s6n","logo":"styles_logo__RjXpQ","description":"styles_description__npvV3"};